import React, { useState } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import Login from "./Pages/Login";
import ForgotPassword from "./Components/ForgotPassword";
import Home from "./Pages/Home";
import Profile from "./Pages/Profile";
import AppField from "./Pages/AppField";
import Documents from "./Pages/Documents";
import Charts from "./Pages/Charts";
import Forecast from "./Pages/Forecast";
import Notes from "./Pages/Notes";
import AddNotes from "./Components/AddNotes";
import EditNotes from "./Components/EditNotes";
import AddSubnote from "./Components/AddSubnote";
import EditSubnote from "./Components/EditSubnote";
import Results from "./Components/Results";
import Statement from "./Components/Statement";
import PrivateRoutes from "./Components/PrivateRoutes";
import Search from "./Components/Search";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function App() {

  return (
    <div className="App">
      <HashRouter basename="/">
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route path="/Profile" exact element={<Profile />} />
            <Route path="/AppField" exact element={<AppField />} />
            <Route path="/Notes" exact element={<Notes />} />
            <Route path="/Notes/AddNotes" element={<AddNotes />} />
            <Route path="/Notes/EditNotes" element={<EditNotes />} />
            <Route path="/Notes/AddSubnote/:id" element={<AddSubnote />} />
            <Route path="/Notes/EditSubnote/:id" element={<EditSubnote />} />
          </Route>
          <Route path="/" element={<Login />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
          <Route path="/Documents" element={<Documents />} />
          <Route path="/Charts" element={<Charts />} />
          <Route path="/Forecast" element={<Forecast />} />
          <Route path="/Results" element={<Results />} />
          <Route path="/Statement" element={<Statement />} />
          <Route path="/Statement/:monthYear" element={<Statement />} />
          <Route path="/Search" element={<Search />} />
        </Routes>
      </HashRouter>
      <ToastContainer />
    </div>
  );
}

export default App;
